<div class="border border-surface-200 dark:border-surface-700 rounded-lg overflow-hidden h-screen w-full flex flex-col">
    <p-sidebar-layout class="h-full w-full relative flex-1">
        @if (backdrop) {
        <p-sidebar-backdrop class="absolute!" />
        }
        <p-sidebar id="variants-demo" [variant]="variant" [collapsible]="isMobile() ? 'offcanvas' : 'icon'"
            [side]="side" [overlay]="overlay" [openOnHover]="openOnHover" [(open)]="open">
            <p-sidebar-spacer />
            <p-sidebar-aside>
                <p-sidebar-panel>
                    <p-sidebar-header>
                        <p-sidebar-menu>
                            <p-sidebar-menu-item>
                                <button pSidebarMenuButton class="p-1!" (click)="companyMenu.toggle($event)">
                                    <div class="flex size-6 shrink-0 items-center justify-center rounded-md text-white text-xs font-bold leading-none bg-linear-to-br"
                                        [class]="activeCompany.color">
                                        {{ activeCompany.logo }}
                                    </div>
                                    <span class="font-semibold text-sm">{{ activeCompany.name }}</span>
                                    <svg data-p-icon="chevron-down" class="ml-auto"></svg>
                                </button>
                                <p-menu #companyMenu [model]="companyItems" [popup]="true" appendTo="body">
                                    <ng-template #item let-item>
                                        @if (item.separator) {
                                        <hr class="border-surface-200 dark:border-surface-700 my-1" />
                                        } @else if (item.logo) {
                                        <a class="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-surface-100 dark:hover:bg-surface-800 rounded-md"
                                            (click)="item.command?.()">
                                            <div class="flex size-5 shrink-0 items-center justify-center rounded-sm text-white text-[0.625rem] font-bold leading-none bg-linear-to-br"
                                                [class]="item.color">{{ item.logo }}</div>
                                            <span class="text-sm">{{ item.label }}</span>
                                            @if (item.active) {
                                            <svg data-p-icon="check" class="ml-auto"></svg>
                                            }
                                        </a>
                                        } @else {
                                        <a class="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-surface-100 dark:hover:bg-surface-800 rounded-md"
                                            (click)="item.command?.()">
                                            @if (item.icon) {
                                            <svg [pIcon]="item.icon"></svg>
                                            }
                                            <span class="text-sm">{{ item.label }}</span>
                                        </a>
                                        }
                                    </ng-template>
                                </p-menu>
                            </p-sidebar-menu-item>
                        </p-sidebar-menu>
                    </p-sidebar-header>
                    <p-sidebar-content>
                        @for (group of navGroups(); track $index) {
                        <p-sidebar-group>
                            <p-sidebar-group-content>
                                <p-sidebar-menu>
                                    @for (item of group.items; track item.label) {
                                        @if (item.visible !== false) {
                                            <p-sidebar-menu-item [collapsible]="!!item.subItems"
                                                [defaultOpen]="hasActiveSub(item)">
                                                <button pSidebarMenuButton [isActive]="isItemActive(item)"
                                                    [routerLink]="item.subItems ? null : item.routerLink"
                                                    (click)="item.subItems ? null : clearKeys()"
                                                    routerLinkActive="active">
                                                    <svg [pIcon]="item.icon"></svg>
                                                    <span>{{ item.label }}</span>
                                                    @if (item.subItems) {
                                                    <svg data-p-icon="chevron-down" class="ml-auto"></svg>
                                                    }
                                                </button>
                                                @if (item.badge) {
                                                <p-sidebar-menu-badge>{{ item.badge }}</p-sidebar-menu-badge>
                                                }
                                                @if (item.subItems) {
                                                <p-sidebar-menu-sub>
                                                    @for (sub of item.subItems; track sub.label) {
                                                        @if (sub.visible !== false) {
                                                            <p-sidebar-menu-sub-item>
                                                                <button pSidebarMenuSubButton [isActive]="isSubActive(sub)"
                                                                    [routerLink]="sub.routerLink" routerLinkActive="active"
                                                                    (click)="clearKeys()">
                                                                    <span>{{ sub.label }}</span>
                                                                </button>
                                                            </p-sidebar-menu-sub-item>
                                                        }
                                                    }
                                                </p-sidebar-menu-sub>
                                                } @else if (!item.badge) {
                                                <button pSidebarMenuAction showOnHover><svg
                                                        data-p-icon="sign-out"></svg></button>
                                                }
                                            </p-sidebar-menu-item>
                                        }
                                    }
                                </p-sidebar-menu>
                            </p-sidebar-group-content>
                        </p-sidebar-group>
                        }
                    </p-sidebar-content>
                    <p-sidebar-footer>
                        <!-- Modo Oscuro o Claro -->
                        <p-sidebar-menu-item>
                            <button pSidebarMenuButton (click)="themeService.toggle()">
                                @if (themeService.isDark()) {
                                <svg data-p-icon="Sun"></svg>
                                <span>Modo Claro</span>
                                } @else {
                                <svg data-p-icon="Moon"></svg>
                                <span>Modo Oscuro</span>
                                }
                            </button>
                        </p-sidebar-menu-item>

                        <!-- Nombre del usuario -->
                        <p-sidebar-menu>
                            <p-sidebar-menu-item>
                                <button pSidebarMenuButton class="p-1!" (click)="userMenu.toggle($event)">
                                    <p-avatar [label]="userInitials()" shape="circle" class="size-6 shrink-0 text-xs" />
                                    <span>{{ userDisplayName() }}</span>
                                    <svg data-p-icon="chevron-down" class="ml-auto"></svg>
                                </button>
                                <p-menu #userMenu [model]="userItems" [popup]="true" appendTo="body">
                                    <ng-template #item let-item>
                                        @if (item.separator) {
                                        <hr class="border-surface-200 dark:border-surface-700 my-1" />
                                        } @else {
                                        <a class="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-surface-100 dark:hover:bg-surface-800 rounded-md"
                                            (click)="item.command?.()">
                                            @if (item.icon) {
                                            <!-- Cambiamos <span> por <svg [pIcon]> -->
                                            <svg [pIcon]="item.icon" [spin]="item.spin" class="size-2"></svg>
                                            }
                                            <span class="text-sm">{{ item.label }}</span>
                                        </a>
                                        }
                                    </ng-template>
                                </p-menu> </p-sidebar-menu-item>
                        </p-sidebar-menu>
                    </p-sidebar-footer>
                    <button pSidebarRail></button>
                </p-sidebar-panel>
            </p-sidebar-aside>
        </p-sidebar>
        <p-sidebar-main>
            <header class="flex h-12 items-center justify-between border-b border-surface-200 dark:border-surface-700 px-4 gap-4">
                <div class="flex-1 flex items-center gap-2 overflow-hidden">
                    <button pButton pSidebarTrigger target="variants-demo" severity="secondary" text size="small"
                        (click)="onSidebarTriggerClick()">
                        <svg data-p-icon="sidebar"></svg>
                    </button>
                    <span class="text-sm font-medium truncate">{{ currentPageTitle() }}</span>
                </div>

                <div class="flex-none flex justify-center">
                    <app-command-menu [navGroups]="navGroups()"></app-command-menu>
                </div>

                <div class="flex-1 flex justify-end items-center">
                    <img [src]="companyLogo()" alt="CCL logo" class="h-7 w-auto max-w-[8rem] object-contain flex-shrink-0">
                </div>
            </header>
            <div class="flex-1 p-2 flex flex-col gap-2 overflow-hidden min-w-0">
                <ng-content></ng-content>
                <!-- <div class="rounded-lg bg-surface-100 dark:bg-surface-800 w-full h-full"></div> -->
            </div>
        </p-sidebar-main>
    </p-sidebar-layout>
</div>